import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, DatePicker } from 'antd';

import type { InputDefaultProps } from '../types';
import { Label } from '../../../components/Label';
import { FormItem } from '../../../components/FormItem';

export function AnalysisDate({ fieldName }: Readonly<InputDefaultProps>) {
	const title = I18n.get('Analysis date');

	return (
		<Col xs={24}>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Label isRequired>{title}</Label>
				</Col>
				<Col span={24}>
					<FormItem
						name={[fieldName, 'analysis_date']}
						rules={[{ required: true, message: I18n.get('Enter the analysis date') }]}
					>
						<DatePicker
							allowClear
							format="L"
							size="large"
							placeholder={title}
							style={{ width: '100%' }}
							disabledDate={(current) => current && current.valueOf() >= Date.now()}
						/>
					</FormItem>
				</Col>
			</Row>
		</Col>
	);
}
